import type { CandidateLoginResult } from '@/lib/api';
import type { CandidateUser } from '@/types/database';

/** Builds session `CandidateUser` from a candidate auth API response (typed, no `any`). */
export function candidateUserFromLoginResult(
  result: CandidateLoginResult,
): CandidateUser {
  const u = result.user;
  return {
    id: u.id,
    guid: u.guid,
    staffId: result.staffId ?? null,
    applicantRefNo: u.applicantRefNo ?? null,
    emailAddress: u.emailAddress,
    surname: u.surname,
    firstName: u.firstName,
    middleName: u.middleName,
    gender: u.gender,
    dateOfBirth: u.dateOfBirth,
    grade: u.grade,
    designation: u.designation,
    dateOfEmployment: u.dateOfEmployment,
    nrd: u.nrd,
    yearsOfService: u.yearsOfService,
    dateOfLastPromotion: u.dateOfLastPromotion,
    phoneExt: u.phoneExt,
    gsmNumber: u.gsmNumber,
    officeLabel: u.officeLabel,
    departmentCode: u.departmentCode,
    department: u.department,
    divisionCode: u.divisionCode,
    division: u.division,
    directorateCode: u.directorateCode,
    directorate: u.directorate,
    locationCode: u.locationCode,
    location: u.location,
    skillPoolId: u.skillPoolId,
    performanceTracking: u.performanceTracking,
    verifiedQualificationWithDate: u.verifiedQualificationWithDate,
    rank: u.rank,
    eligibleForM3: u.eligibleForM3,
    eligibleForM4: u.eligibleForM4,
    eligibleForM5: u.eligibleForM5,
    eligibleForM6: u.eligibleForM6,
    m3EligibilityReason: u.m3EligibilityReason,
    m4EligibilityReason: u.m4EligibilityReason,
    m5EligibilityReason: u.m5EligibilityReason,
    m6EligibilityReason: u.m6EligibilityReason,
    eligibleGrades: result.eligibleGrades,
    undertakingAcceptedAt: u.undertakingAcceptedAt,
    isActive: u.isActive,
    lastLoginAt: u.lastLoginAt,
    createdAt: u.createdAt,
  };
}
